export const UPDATE_PROCESS_POPUP = {
    SPLIT_PROCESS: 'פצל‎',
    START_TIME: 'START TIME',
    END_TIME: 'END_TIME',
    REMARK: 'הערות',
    DURATION:'DURATION'
}
export const PROJECT_MANAGER = "מנהל פרויקט"